module.exports = __webpack_public_path__ + "static/media/lobbyMobile.cda78c05.jpg";